import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: true,
  isFileUploading: false,
  documentsData: [],
  shouldReloadDocuments: false,
  selectedPhotosAndDocumentsToAttach: [],
};

const userFormDocumentsSlice = createSlice({
  name: 'userFormDocuments',
  initialState: initialState,
  reducers: {
    setUserDocumentsForm(state, { payload }) {
      state.isLoading = Object.prototype.hasOwnProperty.call(
        payload,
        'isLoading'
      )
        ? payload.isLoading
        : state.isLoading;
      state.isFileUploading = Object.prototype.hasOwnProperty.call(
        payload,
        'isFileUploading'
      )
        ? payload.isFileUploading
        : state.isFileUploading;
      state.documentsData = Object.prototype.hasOwnProperty.call(
        payload,
        'documentsData'
      )
        ? payload.documentsData
        : state.documentsData;
      state.newUserDocument = Object.prototype.hasOwnProperty.call(
        payload,
        'newUserDocument'
      )
        ? payload.newUserDocument
        : state.newUserDocument;
    },

    triggerDocumentsReload(state) {
      state.shouldReloadDocuments = true;
    },
    setSelectedPhotosAndDocumentsToAttach(state, { payload }) {
      state.selectedPhotosAndDocumentsToAttach = payload;
    },
    resetDocumentsReload(state) {
      state.shouldReloadDocuments = false;
    },
  },
});

export const {
  setUserDocumentsForm,
  triggerDocumentsReload,
  resetDocumentsReload,
  setSelectedPhotosAndDocumentsToAttach,
} = userFormDocumentsSlice.actions;

export const userFormDocumentsReducer = userFormDocumentsSlice.reducer;
